import moment from 'moment';
import { isValidDate } from './utils';
export const stringToDate = (str) => {
    if (isValidDate(str))
        return new Date(str);
    if (typeof str === 'string') {
        const date = moment(str, ['h:m a', 'H:m']).toDate();
        if (isValidDate(date))
            return new Date(date);
        return null;
    }
    return null;
};
//# sourceMappingURL=stringToDate.js.map